import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-200 pt-14 pb-8 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-foreground-900 tracking-tight">
                Basetao<span className="text-accent-600">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              The most comprehensive online resource platform about Basetao Spreadsheet — featuring reviews, guides, templates, and expert comparisons.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit kaspreadsheet.com
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Home</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Basetao Spreadsheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Buy It Now</a></li>
              <li><Link to="/article/basetao-review" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Shopping Guide</Link></li>
              <li><Link to="/article/basetao-beginner-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Beginner Guide</Link></li>
              <li><Link to="/article/basetao-coupon" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Coupon Codes</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Top Articles</h4>
            <ul className="space-y-2.5">
              {articles.slice(0, 8).map((article) => (
                <li key={article.slug}>
                  <Link to={`/article/${article.slug}`} className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    {article.title.length > 40 ? article.title.slice(0, 40) + '...' : article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} BasetaoSheet Forum. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Terms of Service</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}